import { getSessionBrands } from '/@/store/session/selectors';

export const getBrands = (state) => {
    return getSessionBrands(state)['corn'];
};

export const getType = (state) => {
    return state.nitrogenRecommendation.type || 'fixed';
};

export const getPlantingDate = (state) => {
    return state.nitrogenRecommendation.plantingDate || undefined;
};

export const getApplicationDate = (state) => {
    return state.nitrogenRecommendation.applicationDate || undefined;
};

export const getEstimatedApplicationDate = (state) => {
    return state.nitrogenRecommendation.estimatedApplicationDate || undefined;
};

export const getPhone = (state) => {
    return state.nitrogenRecommendation.phone || undefined;
};

export const getSelectedHybrid = (state) => {
    return state.nitrogenRecommendation.hybrid || undefined;
};

export const getNitrogenSource = (state) => {
    return state.nitrogenRecommendation.nitrogenSource || undefined;
};

export const getCropMonitoring = (state) => {
    return state.nitrogenRecommendation.cropMonitoring;
};

export const getCompanyName = (state) => {
    return state.nitrogenRecommendation.companyName || undefined;
};

export const getNitrogenRecommendationsData = (state) => {
    return state.nitrogenRecommendation;
};

export const getManagementZones = (state) => {
    return state.nitrogenRecommendation.managementZones || [];
};

export const getManagementZoneFile = (state) => {
    return state.nitrogenRecommendation.managementZoneFiles || undefined;
};

const areManagementZonesValid = (state) => {
    const managementZones = getManagementZones(state);
    const managementZonesFile = getManagementZoneFile(state);
    if (state.nitrogenRecommendation.type === 'variable' && managementZonesFile && managementZonesFile.length !== 3) {
        return false;
    }

    if (managementZones.length === 0) return false;
    return !managementZones.some(({ valid }) => !valid);
};

export const getManagementZone = (state, id) => {
    return state.nitrogenRecommendation.managementZones.find((mz) => mz.id === id) || undefined;
};

export const isValidForm = (state, type) => {
    const keys = ['plantingDate', 'estimatedApplicationDate', 'hybrid', 'nitrogenSource'];
    if (type === 'variable') keys.push('managementZoneFiles');
    return areManagementZonesValid(state) && !keys.some((key) => !state.nitrogenRecommendation[key]);
};

// Validity of the "Información de la siembra" step only (no management-zone checks,
// which belong to the "Ambiente" step).
export const isSiembraStepValid = (state) => {
    const keys = ['plantingDate', 'estimatedApplicationDate', 'hybrid', 'nitrogenSource'];
    return !keys.some((key) => !state.nitrogenRecommendation[key]);
};
